import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-location-blocks',
    templateUrl: './location-blocks.component.html',
    styleUrls: ['./location-blocks.component.css'],
    standalone: false
})
export class LocationBlocksComponent implements OnInit {
  @Input() locationId!: string;

  constructor() { }

  ngOnInit(): void {
  }
}
